module.exports = __webpack_public_path__ + "static/img/公司9.90d91b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司9.jpg
// module id = B352
// module chunks = 1